/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import type { Color } from "@packages/ui";
import {
  Mask,
  spacing,
  useIsDesktopViewport,
  useThemeValues,
} from "@packages/ui";
import type { PropsWithChildren } from "react";

type StickyModalButtonsProps = PropsWithChildren<{
  css?: Interpolation;
  listCSS?: Interpolation;
  backgroundColor?: Color;
}>;

export const StickyModalButtons = ({
  children,
  css: cssProp,
  listCSS,
  backgroundColor: overrideBackgroundColor,
}: StickyModalButtonsProps) => {
  const isDesktop = useIsDesktopViewport();
  const theme = useThemeValues();
  const colorKey =
    overrideBackgroundColor ??
    (isDesktop ? "onOverlayBackground" : "background");
  const bgColor =
    theme.semanticColors[colorKey] ??
    theme.constantSemanticColors[colorKey] ??
    colorKey;

  return (
    <div
      css={[
        {
          bottom: spacing.none,
          display: "flex",
          flexDirection: "column",
          marginTop: "auto",
          position: "sticky",
          "::after": {
            background: bgColor,
            content: '""',
            height: spacing.l,
            position: "absolute",
            top: spacing.full,
            width: spacing.full,
          },
        },
        cssProp,
      ]}
    >
      <Mask direction="to top" size="s" color={colorKey} />
      <div
        css={[
          {
            background: bgColor,
            display: "flex",
            flexDirection: "column",
            gap: spacing.s,
          },
          listCSS,
        ]}
      >
        {children}
      </div>
    </div>
  );
};
